export class EmailLog {
    id: number = -1;

    to: string = '';
    from: string = '';
    content: string = '';
    subject: string = '';
    createdAt: string = '';
    updatedAt: string = '';
}